module.exports = __webpack_public_path__ + "static/media/sv.27c5cfe3.svg";